import { EuroOutlined } from '@ant-design/icons';
import { yup } from '@framework/validation';
import React from 'react';
import { Datatype } from '../../../../expressions/datatype/Datatype';
import { getSimpleWidgetReference } from '../../../../expressions/references/builder/getSimpleWidgetReference';
import { CustomWarningsRule } from '../../../../rules/repository/custom-warnings/CustomWarnings.rule';
import { RequiredRule } from '../../../../rules/repository/required/Required.rule';
import { ValueRangeRule } from '../../../../rules/repository/value-range/ValueRange.rule';
import type { IWidgetType } from '../../../IWidgetType';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget';
import { InputCommonTranslationSchema } from '../../translations/InputCommonTranslationSchema';
import { createCommonFormSchema } from '../common/createCommonFormSchema';
import { CurrencyWidgetComponent } from './CurrencyWidgetComponent';
import {
  CurrencyWidgetConfigComponent,
  currencyInputConfigValidator,
} from './CurrencyWidgetConfigComponent';
import type { ICurrencyWidget } from './ICurrencyWidget';

export const CURRENCY_METATADATA_TYPE = 'currency';

export const CurrencyWidgetType: IWidgetType<ICurrencyWidget> = {
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Input,
  type: WidgetType.Currency,
  name: 'Campo Valuta',
  icon: <EuroOutlined />,
  hasValue: true,
  getReference: getSimpleWidgetReference(Datatype.Number),
  formComponent: CurrencyWidgetComponent,
  createFormSchema: ({ widget }) =>
    createCommonFormSchema(
      yup.string().notRequired().meta({
        /**
         * Sovrascrivo il tipo di dato indicato nel riferimento dei
         * metadati estratti (exportMetadataDirective). Questo è utile per i widget che hanno un tipo
         * diverso o specifico rispetto a quello del proprio schema (e.g. CurrencyWidget è una `string`
         * ma deve essere esportato come `CURRENCY_METATADATA_TYPE`).
         */
        exportedMetadataType: CURRENCY_METATADATA_TYPE,
      }),
      widget,
    ),
  previewComponent: CurrencyWidgetComponent,
  configValidator: currencyInputConfigValidator,
  configComponent: CurrencyWidgetConfigComponent,
  translationSchema: InputCommonTranslationSchema,
  rules: [RequiredRule, ValueRangeRule, CustomWarningsRule],
};
